/** Scenes that play: leaving one also closes its HUD and results. */
const PLAY_SCENES = ['Level', 'RaceLevel', 'DuelLevel'];
/** Scenes drawn over a screen rather than being one. */
const OVERLAYS = new Set(['Wipe', 'Hud', 'Results', 'Reveal']);

/**
 * Where a link that opened the app goes, given the scenes now running (in scene-list order):
 * - `'wait'` while a lawn, race or match is still being played, or a reveal is showing (the menu
 *   opens the link when the player is next there);
 * - otherwise the screen to leave for the menu: the play scene once its results are up, else the
 *   first scene that is not an overlay. Never an overlay: leaving the HUD after a head-to-head
 *   match left the match and its results drawn over the menu, hiding the invite (owner, build 26).
 */
export function linkExit(active: readonly string[]): 'wait' | { from: string } | null {
  if (active.includes('Reveal')) return 'wait';
  const play = active.find((key) => PLAY_SCENES.includes(key));
  if (play) return active.includes('Results') ? { from: play } : 'wait';
  const screen = active.find((key) => !OVERLAYS.has(key));
  return screen ? { from: screen } : null;
}
